import { render, staticRenderFns } from "./CreateOwner.vue?vue&type=template&id=0cc2d9f5"
import script from "./CreateOwner.vue?vue&type=script&lang=js"
export * from "./CreateOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports